import React from 'react';
import ReactSpeedometer from 'react-d3-speedometer';

const AssessmentGaugeChart = ({score, min = 100, max = 700, segmentStops}) => (
  <div className="flex items-center flex-col justify-center rounded bg-white80 xl:bg-white  w-full">
    <div className="flex w-full justify-end px-10 pt-2">
      <p className="text-[40px]">{score}</p>
    </div>
    <ReactSpeedometer
      value={score}
      needleHeightRatio={0.7}
      labelFontSize={'12px'}
      valueTextFontSize={'23px'}
      textColor="grey"
      height={250}
      width={350}
      ringWidth={35}
      paddingHorizontal={10}
      forceRender={false}
      needleColor="#333333"
      minValue={min}
      maxValue={max}
      customSegmentStops={segmentStops}
      segmentColors={['#156506', '#66F34D', '#FACD3C', '#DD800D', '#CB4305']}
    />
  </div>
);
export default AssessmentGaugeChart;
